var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data.is_locked)?_c('btn',{attrs:{"icon":"fas fa-arrow-right","cssClass":"btn btn-sm btn-primary","click":() => _vm.$emit('locked', false)}}):_c('btn',{attrs:{"icon":"fas fa-pencil","cssClass":"btn btn-sm btn-success","click":() => _vm.$emit('locked', true)}})
}
var staticRenderFns = []

export { render, staticRenderFns }